/**
 * Раньше мы использовали библиотеку react-scroll. Но выяснилось, что мы
 * используем лишь часть ее функциональности. Поэтому было приянато решение
 * сделать мини библиотеку, которая только скролит от одного места к другому.
 * Апи модуля такое же как и react-scroll
 *
 * Данная реализация использует стандарный scroll-behavior: smooth, который
 * не поддерживается в сафари и IE, но было принято решение не подключать
 * полифил, а оставить поведение как есть.
 */
export const scroller = {
  scrollTo(to) {
    const target = document.getElementById(to) || document.getElementsByName(to)[0] || document.getElementsByClassName(to)[0];
    const top = target.getBoundingClientRect().top + pageYOffset;
    window.scroll({ top, behavior: 'smooth' });
  },
};

export function Element(props) {
  return <div {...props} />;
}
